import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../api/client";
import { useAuth } from "../context/AuthContext";
import { Eye, EyeOff } from "lucide-react";
import bgmain from "../../src/Images/main.jpg";

const SignIn = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [generalError, setGeneralError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setGeneralError("");

    try {
      const data = await authApi.login(formData);
      login(data);
      setFormData({ email: "", password: "" });
      const role = data?.user?.role;
      if (role === "admin") navigate("/dashboard");
      else if (role === "provider") navigate("/");
      else navigate("/");
    } catch (error) {
      console.error("Error during login:", error);
      const status = error?.status;
      const data = error?.data || {};
      if (status === 401 || data?.code === "UNAUTHORIZED") {
        setGeneralError("Invalid email or password");
      } else if (data?.code === "VALIDATION_ERROR") {
        const first =
          Array.isArray(data.errors) && data.errors.length > 0
            ? data.errors[0]?.message
            : null;
        setGeneralError(first || data?.message || "Validation error");
      } else {
        setGeneralError(data?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen min-w-full flex items-center fl">
      <img
        src={bgmain}
        alt="Hero Background"
        className="absolute min-h-screen inset-0 w-full h-full object-cover z-[-10] blur-sm"
      />
      <div className="w-11/12 md:w-2/5 mx-auto px-6 py-10 poppins-regular bg-gray-100/30 backdrop-blur-sm rounded-lg">
        <h2 className="text-3xl poppins-bold uppercase text-center mb-8 text-gray-800">
          Sign In
        </h2>

        {generalError && (
          <div className="mb-4 p-3 rounded bg-red-50 text-red-700 border border-red-200">
            {generalError}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Email */}
          <div>
            <label className="block text-sm font-semibold uppercase text-gray-900 mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-semibold uppercase text-gray-900 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                required
                value={formData.password}
                onChange={handleChange}
                className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
              >
                {showPassword ? (
                  <EyeOff className="h-5 w-5" />
                ) : (
                  <Eye className="h-5 w-5" />
                )}
              </button>
            </div>
          </div>

          {/* Submit */}
          <div className="text-right">
            <button
              type="submit"
              disabled={loading}
              className={`bg-gradient-to-r from-blue-500 to-blue-700 uppercase px-6 py-2 text-white rounded-lg mulish-bold transition ${
                loading ? "opacity-50 cursor-not-allowed" : "hover:opacity-90"
              }`}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default SignIn;
